import React from 'react';
import AccountDetails from './Partials/AccountDetails';
import DiscordConnection from './Partials/DiscordConnection';
import PasswordChange from './Partials/PasswordChange';

const Profile: React.FC = () => {
    return (
        <div className="mx-auto max-w-4xl">
            <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
                <AccountDetails />
                <DiscordConnection />
                <PasswordChange />
            </div>
        </div>
    );
};

export default Profile;
